import React from 'react';
import { Clock3, CalendarDays, Bell, Search, User } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useData } from '../context/DataContext';
import { useLoading } from '../hooks/useLoading';
import { Skeleton } from './ui/Skeleton';
import { NotificationsDropdown } from './NotificationsDropdown';

export function Topbar() {
  const { user } = useAuth();
  const { allEnrollments, professors } = useData();
  const loading = useLoading(400);
  
  // Buscar dados atualizados da base global
  const student = user?.type === 'student' ? allEnrollments.find(e => e.enrollmentId === user.enrollmentId) : null;
  const professor = user?.type === 'professor' ? professors.find(p => p.enrollmentId === user.enrollmentId) : null;
  
  const userName = student?.fullName || professor?.fullName || user?.name || 'Usuário';
  
  const welcomeMessage = user?.type === 'professor' 
    ? `Bem-vindo, ${userName} 👋` 
    : `Bem-vindo(a), ${userName.split(' ')[0]}!`;
    
  const subtitle = user?.type === 'professor'
    ? 'Painel de Gestão Docente'
    : 'Portal de Ingresso e Matrícula.';

  return (
    <header className="topbar">
      <div className="topMain">
        {loading ? (
          <>
            <Skeleton className="h-8 w-64 mb-2" />
            <Skeleton className="h-4 w-48" />
          </>
        ) : (
          <>
            <h1 className="text-3xl font-bold tracking-tight">{welcomeMessage}</h1>
            <p className="text-muted">{subtitle}</p>
          </>
        )}
      </div>
      
      <div className="topActions">
        <div className="miniCard clock">
          <Clock3 size={18}/>
          <div>
            <strong>{new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</strong>
            <span>{new Date().toLocaleDateString('pt-BR', { day: '2-digit', month: 'short' })}</span>
          </div>
        </div>
        
        <NotificationsDropdown />

        <div className="profile">
          <div className="profileInfo">
            <strong>{userName}</strong>
            <span>{user?.type === 'professor' ? 'Docente' : user?.type === 'secretaria' ? 'Administrador' : 'Estudante'}</span>
          </div>
          <div className="profileAvatar overflow-hidden flex items-center justify-center bg-purple/10 text-purple font-black">
            <User size={20} />
          </div>
        </div>
      </div>
    </header>
  );
}
